import { NavLink } from 'react-router-dom';
import { useFrameworkQueueCount } from '../../lib/frameworks';

/** Library and Requests: the two halves of the admin Frameworks area. */
export function FrameworkTabs() {
  const waiting = useFrameworkQueueCount();
  return (
    <nav className="tabs" aria-label="Frameworks">
      <NavLink to="/admin/frameworks" end className="tab">
        Library
      </NavLink>
      <NavLink to="/admin/framework-requests" className="tab">
        Requests
        {waiting ? (
          <span className="tab-count" aria-label={`${waiting} waiting`}>
            {waiting}
          </span>
        ) : null}
      </NavLink>
    </nav>
  );
}
